//
//
//
import { selectByPattern } from '../../tags';
export default {
  props: {
    side: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      isResetting: false
    };
  },
  computed: {
    pattern: {
      get: function get() {
        return this.$store.state.elements[this.side][this.index].tag.pattern;
      },
      set: function set(value) {
        this.setTagAttr('pattern', value);
        this.applyPattern();
      }
    }
  },
  methods: {
    setTagAttr: function setTagAttr(name, value) {
      this.$store.commit('elements/setFieldAttr', {
        side: this.side,
        index: this.index,
        field: 'tag',
        attr: name,
        value: value
      });
    },
    reset: function reset() {
      this.isResetting = true;
      this.pattern = '';
      this.isResetting = false;
    },
    applyPattern: function applyPattern() {
      if (this.isResetting) {
        return;
      }

      if (!this.pattern) {
        this.setSelectedTags(null);
        return;
      }

      this.setSelectedTags(selectByPattern(this.pattern, this.$ncsConfig.tags.list));
    },
    setSelectedTags: function setSelectedTags(selected) {
      this.setTagAttr('tagSelectorUsed', 'pattern');
      this.setTagAttr('value', selected);
    }
  }
};